/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toast_Topic_Delete_FailedInputs */

const en_toast_topic_delete_failed = /** @type {(inputs: Toast_Topic_Delete_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to delete topic`)
};

const nl_toast_topic_delete_failed = /** @type {(inputs: Toast_Topic_Delete_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fout bij het verwijderen van onderwerp`)
};

/**
* | output |
* | --- |
* | "Failed to delete topic" |
*
* @param {Toast_Topic_Delete_FailedInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const toast_topic_delete_failed = /** @type {((inputs?: Toast_Topic_Delete_FailedInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Topic_Delete_FailedInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_toast_topic_delete_failed(inputs)
	return en_toast_topic_delete_failed(inputs)
});